import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Jumbotron, Button } from 'reactstrap';

const Banner = () => {
  const dispatch = useDispatch();
  const showBanner = useSelector(state => state.auth.showBanner);

  if (!showBanner) return null;

  return (
    <Container className='mt-3'>
      <Button
        close
        className='px-2 py-1'
        onClick={e => dispatch({ type: `Auth/HIDE_BANNER` })}
        title='Скрыть и больше не показывать'
      />
      <Jumbotron className='bg-white mb-0 border'>
        <h2 className='text-center'>Финансовая защита на случай COVID-19</h2>
        <h2 className='text-center font-weight-bold text-success'>Ю-Защита. Домашний иммунитет</h2>
        <div className='text-center mt-4'>
          <Button
            color='success'
            size='lg'
            tag='a'
            href='//ulife.ru/protect/covid19online/'
            target='_blank'
            rel='noopener noreferrer'
          >
            Купить онлайн
          </Button>
        </div>
      </Jumbotron>
    </Container>
  );
};

export default Banner;
